export enum QUERY_STRING_PARAM_STRATEGY {
  STRING = 'string',
  ARRAY = 'array',
}

export enum GTM_EVENT_PAGE_TEMPLATE {
  home = 'homepage',
  article = 'article_page',
  product = 'product_page',
  productList = 'products_list_page',
  searchResults = 'search_results_page',
  contactUs = 'contact_us_page',
  login = 'login_page',
  signUp = 'sign_up_page',
  other = 'other_page',
}

export enum API_HTTP_STATUS_CODE {
  OK = 200,
  METHOD_NOT_ALLOWED = 405,
  INTERNAL_SERVER_ERROR = 500,
}

export enum SHOPPABLE_PLUGIN {
  ADIMO = 'Adimo',
  MIKMAK = 'MikMak',
  PRICE_SPIDER = 'Price spider',
}

export enum GTM_LOCALSTORAGE_DATA {
  lastRetailerTitle = 'LAST_RETAILER_TITLE',
  lastProductIndex = 'LAST_PRODUCT_INDEX',
}

export const FIELD_NAME_VARIANT_AND_ICON = 'Variant_And_Icon';
